export const DEFAULT_PARCEL_KIND = 'Home';
export const createParcelKindState = () => ({
    name: '',
    displayName: '',
    description: '',
    color: '#000000',
    icon: '',
});
